import styled from "styled-components";

export const Title = styled.h1`
  font-size: 26px;
  margin-bottom: 6px;
`;

export const Subtitle = styled.div`
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 20px;
`;

export const AgendaWrapper = styled.div`
  width: 100%;
  overflow: auto;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: #ffffff;
`;

export const AgendaTable = styled.table`
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  min-width: 420px;
  font-size: 13px;
  color: #40464f;

  th,
  td {
    box-sizing: border-box;
    height: 34px;
    border-right: 1px solid #ededf0;
    border-bottom: 1px solid #ededf0;
    padding: 2px 10px;
    text-align: center;
    vertical-align: middle;
    background-clip: padding-box;
  }

  th.block-start,
  td.block-start {
    border-left: 2px solid #c9ccd4;
  }

  tr.day-end > td {
    border-bottom: 2px solid #c9ccd4;
  }
`;

export const AgendaHead = styled.thead`
  th {
    font-weight: 600;
  }

  tr:last-child th {
    background-color: #f6f6f8;
    color: #6b7280;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    border-bottom: 2px solid #c9ccd4;
  }

  th.day-head {
    background-color: #9AA89A;
    color: white;
    border-right: 2px solid #c9ccd4;
    border-bottom: 2px solid #c9ccd4;
    font-size: 14px;
  }
`;

/**
 * Cabeçalho de cada organizador, na cor que ele escolheu na sua ficha.
 * Com vários organizadores é a cor que diz de quem é cada bloco.
 */
export const OrganizerHead = styled.th`
  background-color: ${({ colour }) => colour} !important;
  color: ${({ textColour }) => textColour} !important;
  font-size: 14px !important;
  border-bottom: 2px solid #c9ccd4;
`;

export const OrganizerSubHead = styled.th`
  border-bottom: 2px solid ${({ colour }) => colour} !important;
`;

/** Bloco de um organizador que não tem horas livres nesse dia. */
export const NoSlotsCell = styled.td`
  color: #a9a9b2;
  font-style: italic;
  font-size: 12px;
  background-color: #fbfbfc;
`;

export const DayCell = styled.td`
  background-color: ${({ weekend }) => (weekend ? "#e6ebe6" : "#f2f5f2")};
  border-right: 2px solid #c9ccd4 !important;
  border-bottom: 2px solid #c9ccd4 !important;
  min-width: 140px;

  span.month {
    text-transform: uppercase;
    font-size: 10px;
    letter-spacing: 0.06em;
    color: #8b968b;
    margin-right: 6px;
  }

  span.number {
    font-size: 16px;
    font-weight: 700;
    color: #556455;
  }

  span.weekday {
    font-size: 12px;
    color: #8c8c96;
    margin-left: 6px;
    text-transform: capitalize;
  }
`;

/* Só chegam horários livres, por isso a célula da hora não tem estados */
export const TimeCell = styled.td`
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  color: #5a6472;
  background-color: #fbfbfc;
  width: 110px;
`;

export const EmptyAgenda = styled.div`
  padding: 48px 24px;
  text-align: center;
  color: #8c8c96;
  line-height: 1.6;
`;

/** Acção de marcar uma reunião num horário livre. */
export const BookButton = styled.button`
  border: 1px solid #cfe0cf;
  border-radius: 14px;
  background-color: #e8f0e8;
  color: #4d6b4d;
  cursor: pointer;
  font-size: 11px;
  padding: 2px 12px;
  transition: background-color 0.15s;

  &:hover {
    background-color: #d8e6d8;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const BookCell = styled.td`
  width: 130px;
`;
